
<template>
  <b-modal
    id="modal-center"
    centered
    v-model="show"
    dialog-class="convey-login-modal"
    @close="handleClose"
    hide-footer
    hide-header
    size="xl"
  >
    <b-button variant="light" class="close-btn" @click="handleClose()"
      ><b-icon icon="x" font-scale="1.5"></b-icon
    ></b-button>
    <div class="main d-flex">
      <div
        class="col-md-6 col-sm-12 col-xs-12 convey-user convey-login-modal--main-div"
      >
        <h2 class="title convey-login-modal--header-div">Already a User ?</h2>

        <div class="convey-login-modal--middle-div">
          <div class="convey-user-icon">
            <img src="/images/rcl-logo-badge.png" class="convey-logo" />
            <img src="/images/user_icon-64-64.png" />
          </div>
          <p class="sub-title">Sign-in if you already have an user account!</p>
        </div>
        <div class="convey-login-modal--bottom-div">
          <b-button pill @click="goTologinPage()">Sign in with Email</b-button>
        </div>
      </div>
      <div
        class="col-md-6 col-sm-12 col-xs-12 rapidSos-user convey-login-modal--main-div"
      >
        <h2 class="title convey-login-modal--header-div">RapidSOS</h2>
        <div class="convey-login-modal--middle-div">
          <img
            src="/images/rapidsos-logo-transparent-75x75.png"
            class="rapid-sos-logo"
          />
          <p class="sub-title">Sign-in here if you are a RapidSOS user!</p>
        </div>
        <div class="convey-login-modal--bottom-div">
          <b-button pill @click="goRapidSosLoginPage()"
            >Sign in with RapidSOS</b-button
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
/* eslint-disable */
export default {
  name: "AccountLoginModal",
  props: {
    showModal: Boolean,
  },
  data() {
    return {
      show: this.showModal,
    };
  },
  mounted() {
    console.log("modal show", this.showModal);
  },
  methods: {
    handleClose() {
      this.show = false;
      this.$emit("closeModal");
    },
    goTologinPage() {
      this.$router.push({ path: "/" }).catch(() => {});
    },
    goRapidSosLoginPage() {
      this.$emit("onRapidSosLoginPage");
    },
  },
};
</script>

<style lang="scss">
.convey-login-modal {
  &--main-div {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  &--header-div {
    flex: 0 1 auto;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &--middle-div {
    flex: 0 1 auto;
  }

  &--bottom-div {
    flex: 0 1 auto;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .modal-body {
    padding: 0;
  }
  & .close-btn {
    position: absolute;
    padding: 0;
    right: -4px;
    top: -11px;

    z-index: 999;
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
  }
  & .main {
    width: 100%;
    height: 100%;
    flex-wrap: wrap;
  }
  & .title {
    font-size: 2rem;
    text-align: center;
    // margin: 1.5rem 0;
  }

  & .sub-title {
    font-size: 1rem;
    text-align: center;
    margin-bottom: 1.5rem;
  }
  & .rapidSos-user {
    background: #003687;
    text-align: center;
    padding: 1.5rem;
    height: auto;

    & .rapid-sos-logo {
      margin: 2.3rem;
      width: 84px;
    }
    & .title {
      color: #fcede3;
    }

    & .sub-title {
      color: #fcede3;
    }
    & button {
      background: #b3bece;
      color: #0b0c0d;
      border: inherit;
      border-radius: 0.6rem;
      padding: 8px 12px;
      font-weight: 600;
      width: 200px;
    }
  }
  & .convey-user {
    background: #e66a11;
    text-align: center;
    padding: 1.5rem;
    height: auto;

    & .convey-user-icon {
      position: relative;
      width: fit-content;

      margin: auto;
      padding: 1rem;
    }

    & .convey-logo {
      position: absolute;
      top: 0;
      right: 0;
    }
    & .title {
      color: #ebeff6;
    }

    & .sub-title {
      color: #ebeff6;
    }
    & button {
      background: #4a311f;
      border: inherit;
      border-radius: 0.6rem;
      padding: 8px 12px;
      font-weight: 600;
      width: 200px;
    }
  }
}
</style>